import React, { useEffect, useState } from 'react';
import Base from '../Base';
import Card from '../../components/elements/Card';
import Title from '../../components/common/Title';
import Back from '../../components/common/Back';
import Icon from '../../components/common/Icon';
import NotFound from '../../components/common/NotFound';
import { useTranslation } from 'react-i18next';
import { fetchUserInfo } from '../../utils';

const FinalInstructions = () => {
  const { t } = useTranslation();
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchUserInfo('/event', setEvent, setLoading, setError);
  }, []);

  const html = (event?.final_instructions || '').trim();

  return (
    <Base activeNav="home">
      <Card>
        <Back to="/home" />
        <Title my="1" className="mt-3">
          <Icon name="document" theme="primary" className="me-2" />
          {t('finalInstructions', { defaultValue: 'Final instructions' })}
        </Title>
      </Card>

      {html ? (
        <Card>
          <div
            className="final-instructions"
            dangerouslySetInnerHTML={{ __html: html }}
          />
        </Card>
      ) : (
        <NotFound
          translationKey="finalInstructionsNotPublished"
          loading={loading}
        />
      )}

      {!!error && !loading && (
        <Card>
          <p className="text-danger mb-0">{t(error)}</p>
        </Card>
      )}
    </Base>
  );
};

export default FinalInstructions;
